import {
  GridCard,
  LAYOUT_MINIMAL,
  LAYOUT_RECTANGLE,
  LAYOUT_SQUARE,
} from '@bnnvara/cards/src/components/deprecated/GridCard/GridCard';
import { LandscapeContent } from '@bnnvara/cards/src/components/deprecated/GridCard/LandscapeContent/LandscapeContent';
import { HalfImageHalfTextCardContainer } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardContainer';
import { HalfImageHalfTextCardImage } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardImage';
import { HalfImageHalfTextCardText } from '@bnnvara/cards/src/components/HalfImageHalfTextCard/HalfImageHalfTextCardText';
import { OnHoverTextEffect } from '@bnnvara/cards/src/components/shared/OnHoverTextEffect';
import { Small } from '@bnnvara/cards/src/components/shared/Small';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import { formatDate } from '@bnnvara/helpers';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemeTagMedia } from '../../Tags/ThemeTagMedia';

import resizeImageSource from '../../../helpers/resizeImageSource';
import * as S from './styled';

export const VideoCard = ({
  title,
  image,
  publishDate,
  brand,
  isThemePage,
  layout,
  theme,
  subTheme,
}) => {
  const thumbnail = resizeImageSource(
    image ? image.url || image : '/static/fallbackImages/videofallback.jpg',
    450,
    1
  );

  const pubDate = formatDate(new Date(publishDate), 'dd-MM-yyyy');

  const isSubTheme = theme ? !!theme.parent : false;
  const name = !brand || brand.name === 'portal' ? 'BNNVARA' : brand.name;
  const hideOnProduction = process.env.NODE_ENV !== 'production';

  if (layout === null) {
    return (
      <HalfImageHalfTextCardContainer>
        <HalfImageHalfTextCardImage
          image={{
            alt: title,
            src: thumbnail,
          }}
        />
        <HalfImageHalfTextCardText>
          <OnHoverTextEffect>
            {subTheme && hideOnProduction && (
              <ThemeTagMedia
                themeSlug={isSubTheme ? theme.parent.slug : theme.slug}
                textTransform="upperCase"
              >
                {subTheme.name}
              </ThemeTagMedia>
            )}

            <Title>{title}</Title>
          </OnHoverTextEffect>
          <S.Details>
            <Small>
              {isThemePage && name && `${name}  • `} {pubDate}
            </Small>
          </S.Details>
        </HalfImageHalfTextCardText>
      </HalfImageHalfTextCardContainer>
    );
  }

  return (
    <GridCard layout={layout}>
      <LandscapeContent
        title={title}
        pubDate={pubDate}
        backgroundImage={thumbnail}
      />
    </GridCard>
  );
};

VideoCard.defaultProps = {
  image: null,
  layout: null,
};

VideoCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  theme: PropTypes.shape(),
  isThemePage: PropTypes.bool,
  brand: PropTypes.shape(),
  subTheme: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  publishDate: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    mobile: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_SQUARE]),
    tablet: PropTypes.oneOf([LAYOUT_MINIMAL, LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
    desktop: PropTypes.oneOf([LAYOUT_RECTANGLE, LAYOUT_SQUARE]),
  }),
};

export default VideoCard;
